module.exports = __webpack_public_path__ + "static/media/27.151ff872.jpg";